var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-breadcrumbs',{staticClass:"px-0 bold cta op-60 pb-3 pl-12",attrs:{"items":_vm.breadcrumbs},scopedSlots:_vm._u([{key:"divider",fn:function(){return [_c('v-icon',{attrs:{"size":"6"}},[_vm._v("$verka_right")])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }